
// SVG Icon: location-thick
export default { id: "terriajs-location-thick" };
export const id = "terriajs-location-thick";
export const name = "location-thick";
